import type { DarkenRgb } from "./types";

// Same factor as the agent viewer's room outlines.
const DARKEN_FACTOR = 0.62;

const darkenChannel = (channel: number): number =>
  Math.round(channel * DARKEN_FACTOR);

export const darkenRgb: DarkenRgb = ({ rgb: [red, green, blue] }) => [
  darkenChannel(red),
  darkenChannel(green),
  darkenChannel(blue),
];
